import { render, staticRenderFns } from "./ChatMessages.vue?vue&type=template&id=58acc835&scoped=true"
import script from "./ChatMessages.vue?vue&type=script&lang=js"
export * from "./ChatMessages.vue?vue&type=script&lang=js"
import style0 from "./ChatMessages.vue?vue&type=style&index=0&id=58acc835&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58acc835",
  null
  
)

export default component.exports